import axios from 'axios';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { setDomainData } from '../redux/reducer/domainSlice';
import { getValidAccessToken } from '../services/oauthservice';

const domainMiddleware = (store) => (next) => async (action) => {
  if (action.type === 'domain/checkDomain') {
    try {
      NProgress.start();
      const portal_url = window.location.origin;
      const baseUrl = process.env.REACT_APP_DIC_ADMIN_API;
      const token = await getValidAccessToken();
      const response = await axios.get(`${baseUrl}/v1/motor/get/partners`, {
        params: { portal_url },
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });

      const { PARTNER_ID } = response.data.data[0]
      sessionStorage.setItem('PARTNER_ID', PARTNER_ID);

      store.dispatch(setDomainData(response.data.data[0]));
    } catch (error) {
      console.error('Domain Data Fetch Error:', error);
    } finally {
      NProgress.done();
    }
  }
  return next(action);
};


export default domainMiddleware;
